export default class CommonTypesHelper {
    
    static dateHasValue(dateToValidate?: Date | string | null) : boolean {
        let response = false;

        if (!!dateToValidate) {
            const date = typeof dateToValidate === 'string' ? new Date(dateToValidate) : dateToValidate;
            response = date > new Date(1900, 1, 1);
        }
        
        return response;
    }

    static stringHasValue(stringToValidate?: string) : boolean {
        return (!!stringToValidate && stringToValidate != '9');
   }
}